<template>
  <div>
    <v-btn
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div id="document1" class="printdiv" v-if="lc_data != null">
      <v-row>
        <v-col cols="4" sm="4" md="4" class="mt-5">
          <center>
            <img
              :src="org_basic_data.school_logo"
              alt="school_logo"
              height="150px"
              width="190px"
            />
          </center>
        </v-col>
        <v-col cols="7" sm="7" md="7">
          <center>
            <p>{{ org_basic_data.trust_name }}</p>
            <h1 class="header-style">
              Sanjivani <span class="span-first-letter">I</span>nternational
              <span class="span-first-letter">S</span>chool
            </h1>
            <p>{{ org_basic_data.address }}</p>
            <span class="tdata2 mr-12">Phone: {{ org_basic_data.phone }}</span>
            <span class="tdata2">Email: {{ org_basic_data.email }}</span>
            <h1 class="heading">LEAVING CERTIFICATE</h1>
          </center>
        </v-col>
      </v-row>
      <hr style="border: 1px solid rgb(151, 17, 17)" />
      <center>
        <p>
          (No change in any entry in this certificate shall be made except the
          authority issuing it and infringement of this requirement is liable in
          involve the imposition of penalty such as that of rustication.)
        </p>
      </center>
      <hr style="border: 1px solid rgb(151, 17, 17)" />
      <v-row dense class="ml-2">
        <v-col cols="4" sm="4" md="4"
          ><b>L.C. No. </b> {{ lc_data.certificate_no }}</v-col
        >
        <!-- <v-spacer></v-spacer> -->
         <v-col cols="4" sm="4" md="4" align="center"
          ><b>School  UDISE Code: </b> 27261002204</v-col
        >
        <v-col cols="4" sm="4" md="4"  style="padding-left: 180px;"
          ><b>G. R. No. </b> {{ lc_data.gr_number }}</v-col
        >
      </v-row>
      <hr style="border: 1px solid rgb(151, 17, 17)" />
      <v-row dense class="ml-2">
        <v-col cols="4" sm="4" md="4"><b>School Affiliation Number: </b>1131207</v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" sm="4" md="4"  style="padding-left: 180px;"><b>School Code: </b> 31194</v-col>
      </v-row>
      <div class="row line-height" style="padding: 0px 18px">
        <div>
          <b>1) Full Name of Pupil - </b
          ><span class="underline" style="width: 812px">
            {{ lc_data.fullname }}</span
          >
        </div>
        <div>
          <b>2) Father's Name - </b
          ><span class="underline" style="width: 849px">
            {{ lc_data.father_full_name }}</span
          >
        </div>
        <div>
          <b>3) Mother's Name - </b
          ><span class="underline" style="width: 842px">
            {{ lc_data.mother_first_name }}</span
          >
        </div>
        <div>
          <b>4) Religion & Caste - </b
          ><span class="underline" style="width: 828px">
            {{ lc_data.religion }} - {{ lc_data.caste }}</span
          >
        </div>
        <div>
          <b
            >5) Whether candidate belongs to <br />
            <span class="ml-5">
              Scheduled Tribe or Other Background Communities -
            </span> </b
          ><span class="underline" style="width: 517px">
            {{ lc_data.subcaste }}</span
          >
        </div>
        <div>
          <b>6) Place of Birth - </b
          ><span class="underline" style="width: 851px">
            {{ lc_data.birth_place }}</span
          >
        </div>
        <div>
          <b
            >7) Date of Birth (in Christian Era) <br />
            <span class="ml-5">in Figure & Words - </span></b
          ><span class="underline" style="width: 814px">
            {{ lc_data.dob_fig }} ({{ lc_data.dob_words }})</span
          >
        </div>
        <div>
          <b>8) Nationality - </b
          ><span class="underline" style="width: 871px">
            {{ lc_data.nationality }}</span
          >
        </div>
        <div>
          <b>9) Date of first admission in the School with class - </b
          ><span class="underline" style="width: 547px">
            {{ lc_data.doa }} ({{ lc_data.admittedstandard }})</span
          >
        </div>
        <div>
          <b>10) Class in which the pupil last studied in words & figure - </b
          ><span class="underline" style="width: 478px">
            {{ lc_data.standard }} ({{ lc_data.std_in_words }})</span
          >
        </div>
        <div>
          <b>11) School / Board Annual Examination last taken with result - </b
          ><span class="underline" style="width: 451px">
            {{ lc_data.last_school }}</span
          >
        </div>
        <div>
          <b
            >12) Whether qualified for promotion to higher class if so, <br />
            <span class="ml-5">to which class - </span></b
          ><span class="underline" style="width: 844px"
            >{{ is_promoted_to_next_standard.name }}
            <span v-if="is_promoted_to_next_standard.name === 'Yes'">
              ({{ lc_data.nextstandard.displayname }})
            </span></span
          >
        </div>
        <div>
          <b>13) Whether NCC Cadet/Boy-Scout/Girl-Guide - </b
          ><span class="underline" style="width: 578px">
            {{ whether_ncc_cadet }}</span
          >
        </div>
        <div>
          <b>14) General Conduct - </b
          ><span class="underline" style="width: 806px">
            {{ lc_data.conduct }}
          </span>
        </div>
        <div>
          <b>15) Date of application for certificate - </b
          ><span class="underline" style="width: 660px">
            {{ lc_data.date_of_application }}</span
          >
        </div>
        <div>
          <b>16) Date of issue of certificate - </b
          ><span class="underline" style="width: 720px">
            {{ lc_data.date_of_issue }}</span
          >
        </div>
        <div>
          <b>17) Reason for Leaving the school - </b
          ><span class="underline" style="width: 688px">
            {{ lc_data.reason }}</span
          >
        </div>
        <div>
          <b>18) Remarks - </b
          ><span class="underline" style="width: 877px">
            {{ lc_data.remark }}</span
          >
        </div>
        <div class="mb-2">
          <b>19) Full Name of the Principal - </b
          ><span class="underline" style="width: 725px">
            {{ lc_data.principal_name }}</span
          >
        </div>
      </div>
      <hr style="border: 1px solid rgb(151, 17, 17)" />
      <div class="pl-3">
        <p>
          Certified that the above information is in accordance with the General
          Register of the school.
        </p>
        <p>
          Place:
          <span style="font-weight: 400">{{ org_basic_data.address }}</span>
        </p>
        <p>
          Date: <span style="font-weight: 400">{{ lc_data.gen_date }}</span>
        </p>
      </div>
      <br /><br /><br />
      <v-row class="f-size">
        <v-col cols="4" sm="4" md="4" align="center"
          ><b> Prepared by </b></v-col
        >
        <v-col cols="4" sm="4" md="4" align="center"
          ><b> Class Teacher </b></v-col
        >
        <v-col cols="4" sm="4" md="4" align="center"><b> Principal </b></v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      whether_ncc_cadet: "",
      is_promoted_to_next_standard: "",
      promoted_standard: "",
      is_promoted_to_standard: [
        { name: "Yes", id: "1" },
        { name: "No", id: "2" },
      ],
      standard_list: [],
      promoted_standard_in_words: "",
      show_promoted_standards: false,
      whether_ncc_cadet: "",
    };
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    this.is_promoted_to_next_standard = JSON.parse(
      localStorage.getItem("is_promoted_to_next_standard")
    );
    this.whether_ncc_cadet = JSON.parse(
      localStorage.getItem("whether_ncc_cadet")
    );
  },
};
</script>
<style scoped>
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
  padding: 0px 25px;
}
.heading {
  font-family: "Times New Roman", Times, serif;
}
.underline {
  border-bottom: 1px solid black;
  display: inline-block;
  /* padding-bottom: 3px; */
  text-align: left;
}
.table-data td {
  font-size: medium;
  text-align: left;
}
.inside-header {
  border-right: 1px solid black;
  height: auto;
}
.header-row {
  padding-top: 15px;
}
.tdata2 {
  font-weight: bold;
}
.line-height {
  line-height: 200%;
}
.header-style {
  font-family: serif;
  color: rgb(151, 17, 17);
}
.header-style::first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.header-style .span-first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(151, 17, 17);
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  .line-height {
    line-height: 200% !important;
    font-size: 20px !important;
  }
  #document1 {
    position: absolute;
    /* margin-top: -63px; */
    /* margin-left: -12px; */
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .header-style {
    font-size: 40px;
  }
  p,
  .tdata2 {
    font-size: 20px;
  }
  @page {
    size: A4;
    margin: none;
    margin-top: 40px !important;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */
</style>